/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { ConnectedRouter } from "connected-react-router";
import * as React from "react";
import { connect } from "react-redux";
import { Route } from "react-router";

import { PageHomeConnected } from "../../pages/PageHome/PageHome";
import { PageLoginConnected } from "../../pages/PageLogin/PageLogin";
import { RootState } from "../../types/RootState";
import { AuthRouteConnected } from "./AuthRoute";
import { PageValidateProfileConnected } from "../../pages/PageValidateProfile/PageValidateProfile";

import Notification from "../Notification/Notification";

import { NotificationItem } from "../../types/NotificationItem";
import { PageCustomerConnected } from "../../pages/PageCustomer/PageCustomer";
import { PageCustomersConnected } from "../../pages/PageCustomers/PageCustomers";
import { PageProductConnected } from "../../pages/PageProduct/PageProduct";
import { PageQuotationsConnected } from "../../pages/PageQuotations/PageQuotations";
import { PageQuotationConnected } from "../../pages/PageQuotation/PageQuotation";
import { setNotification } from "../../store/actions";
import { PageAdvisorsConnected } from "../../pages/PageAdvisors/PageAdvisors";

interface AppProps {
    notification: NotificationItem;
    history: any; // TODO @BM
    onNotificationClose(): void;
}

interface AppState {

}

class App extends React.Component<AppProps, AppState> {
    constructor(props: AppProps) {
        super(props);
    }

    public render() {
        return (
            <div>
                <ConnectedRouter history={this.props.history} >
                    <Route
                        path="/"
                        render={_ => {
                            // Call outside JSX: Chrome/Edge 149+ scrollTo() returns a Promise
                            // which React 16 cannot render (error #31 → blank page).
                            window.scrollTo(0, 0);
                            return (
                            <div>
                                {
                                    <Notification
                                        notification={this.props.notification}
                                        onClose={this.props.onNotificationClose}
                                    />
                                }
                                <AuthRouteConnected anonymous={false} path={`/`} render={() => <PageHomeConnected />} />
                                <AuthRouteConnected anonymous={true} path={`/login`} render={() => <PageLoginConnected mode="login" />} />
                                <AuthRouteConnected anonymous={true} path={`/lost-password`} render={() => <PageLoginConnected mode="lostPassword" />} />
                                <AuthRouteConnected anonymous={true} path={`/register`} render={() => <PageLoginConnected mode="register" />} />
                                <AuthRouteConnected anonymous={false} path={`/edit-profile`} render={() => <PageValidateProfileConnected />} />
                                <AuthRouteConnected anonymous={false} path={`/product/:name/:variant?`} render={(props) => <PageProductConnected name={props.match.params.name} variant={props.match.params.variant} />} />
                                <AuthRouteConnected anonymous={false} path={`/quotations`} render={() => <PageQuotationsConnected />} />
                                <AuthRouteConnected anonymous={false} path={`/quotation/:name/:variant?`} render={(props) => <PageQuotationConnected name={props.match.params.name} variant={props.match.params.variant} />} />
                                <AuthRouteConnected anonymous={false} path={`/customers`} render={() => <PageCustomersConnected />} />
                                <AuthRouteConnected anonymous={false} path={`/customer/:id`} render={(props) => <PageCustomerConnected id={props.match.params.id} />} />
                                <AuthRouteConnected anonymous={false} path={`/advisors`} render={(props) => <PageAdvisorsConnected />} />
                            </div>
                            );
                        }}
                    />
                </ConnectedRouter>

            </div>
        );
    }
}

type AppConnectedProps = {
    history: any; // TODO @BM
};

export const AppConnected = connect(
    (state: RootState, ownProps: AppConnectedProps) => ({
        ...ownProps,
        notification: state.notification
    }),
    (dispatch) => ({
        onNotificationClose: () => { dispatch(setNotification(null)); }
    })
)(App);


// WEBPACK FOOTER //
// ./src/components/App/App.tsx